import { render, staticRenderFns } from "./item-select.vue?vue&type=template&id=2d3500ef&scoped=true&"
import script from "./item-select.vue?vue&type=script&lang=js&"
export * from "./item-select.vue?vue&type=script&lang=js&"
import style0 from "./item-select.vue?vue&type=style&index=0&id=2d3500ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3500ef",
  null
  
)

export default component.exports